/* blocks */
import RegistrationForm from '../RegistrationForm/RegistrationForm'

interface Props {
  title: string
  description?: string
}

function InviteOnly({ title, description }: Props) {
  return (
    <section id="invite-only" className="bg-[#060d54] text-white relative">
      <div className="container | py-10 md:py-18">
        <div className="text-center">
          <h2 className="md:flex md:justify-center md:items-baseline md:gap-4 mb-4">
            <div className="text-3xl md:text-4xl font-medium">{title}</div>
          </h2>
          <p className="text-gray-40 text-base md:text-lg mb-8">
            {description}
          </p>
        </div>
        <div>
          <RegistrationForm />
        </div>
      </div>
    </section>
  )
}

export default InviteOnly
